export interface IWarehouseAdminDeliveredTotalsByBuildingProductData {
    id: number;
    name: string|null;
    category: {
        id: number;
        name: string|null;
    }|null;
    active: boolean;
    target_price: number|null;
    buildings: Record<string, {
        delivered: number;
        cost: number;
    }>;
}

export interface IWarehouseAdminDeliveredTotalsByBuildingReportData {
    from: string;
    until: string;
    buildings: string[];
    building_totals: Record<string, number>;
    products: IWarehouseAdminDeliveredTotalsByBuildingProductData[];
}

export class WarehouseAdminDeliveredTotalsByBuildingProductData {
    id: number;
    name: string|null;
    category: {
        id: number;
        name: string|null;
    }|null;
    active: boolean;
    target_price: number|null;
    buildings: Record<string, {
        delivered: number;
        cost: number;
    }>;

    constructor(data: IWarehouseAdminDeliveredTotalsByBuildingProductData) {
        this.id = Number(data.id);
        this.name = data.name ?? null;
        this.category = data.category ?? null;
        this.active = Boolean(data.active);
        this.target_price = data.target_price == null ? null : Number(data.target_price);
        this.buildings = data.buildings ?? {};
    }
}

export default class WarehouseAdminDeliveredTotalsByBuildingReportData {
    from: string;
    until: string;
    buildings: string[];
    building_totals: Record<string, number>;
    products: WarehouseAdminDeliveredTotalsByBuildingProductData[];

    constructor(data: IWarehouseAdminDeliveredTotalsByBuildingReportData) {
        this.from = data.from;
        this.until = data.until;
        this.buildings = data.buildings ?? [];
        this.building_totals = data.building_totals ?? {};
        this.products = (data.products ?? []).map(
            product => new WarehouseAdminDeliveredTotalsByBuildingProductData(product)
        );
    }
}